module.exports = __webpack_public_path__ + "static/media/auth-bg2.9b8f1b40.jpg";